// Namespace under which this app's translations are published in the i18n store.
export const I18N_STORE_PATH = 'communicator-ticketing-ui';
